import Tracker from "@openreplay/tracker";
import env from "@/app/config/env";

let tracker: Tracker | null = null;

export function initOpenReplay(): void {
  if (import.meta.env.DEV) {
    return;
  }

  const { projectKey, ingestPoint } = env.openReplay;

  if (!projectKey || !ingestPoint) {
    return;
  }

  tracker = new Tracker({
    projectKey,
    ingestPoint,
  });

  void tracker.start().catch(() => {
    console.error("Failed to start OpenReplay");
  });
}

export function setTrackerUserID(email: string): void {
  tracker?.setUserID(email);
}
